"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ONE_THIRD = 1 / 3;
const TWO_THIRDS = 2 / 3;
const vue_1 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    name: 'PointsPerTag',
    props: {
        points: {
            type: Object,
            required: true,
        },
    },
    computed: {
        amount() {
            if (this.points.halfPoints === 2) {
                return '2⁄2';
            }
            const points = this.points.points + (this.points.halfPoints / 2);
            const integer = Math.floor(points);
            const fraction = points - integer;
            let vulgarFraction = '';
            if (fraction === 0.5) {
                vulgarFraction = '½';
            }
            else if (Math.abs(fraction - ONE_THIRD) < Number.EPSILON) {
                vulgarFraction = '⅓';
            }
            else if (Math.abs(fraction - TWO_THIRDS) < Number.EPSILON) {
                vulgarFraction = '⅔';
            }
            return `${integer || ''}${vulgarFraction}`;
        },
        cssClasses() {
            if (this.points.halfPoints === 2) {
                return 'points-per-tag points-per-tag--XS';
            }
            return this.amount.length === 1 ?
                'points-per-tag' :
                'points-per-tag points-per-tag--S';
        },
        show() {
            return this.points.points !== 0 || this.points.halfPoints !== 0;
        },
    },
});
